<template>
  <div v-if="smsCampaign" class="px-4 sm:px-6 py-10 bg-gray-100 min-h-full">
    <div class="w-full max-w-7xl mx-auto space-y-8">
      <div v-if="smsCampaign.project">
        <span class="relative z-0 inline-flex shadow-sm rounded-md">
          <RouterLink
            :to="{
              name: 'accounts.show',
              params: {
                accountId: smsCampaign.account.id,
              },
            }"
            class="text-left relative flex flex-col px-4 py-2 rounded-l-md border border-gray-300 bg-white hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <span class="text-xs text-gray-600">Account</span>
            <h3 class="text-sm font-medium text-gray-900">{{ smsCampaign.account.name }}</h3>
          </RouterLink>
          <RouterLink
            :to="{
              name: 'accounts.projects.project',
              params: {
                accountId: smsCampaign.account.id,
                projectId: smsCampaign.project.uuid,
              },
            }"
            class="-ml-px text-left relative flex flex-col px-4 py-2 rounded-r-md border border-gray-300 bg-white hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
          >
            <span class="text-xs text-gray-600">Project</span>
            <h3 class="text-sm font-medium text-gray-900">{{ smsCampaign.project.name }}</h3>
          </RouterLink>
        </span>
      </div>
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            {{ smsCampaign.name }}
          </h2>
        </div>
      </div>

      <NavigationTabs v-if="smsCampaign.status !== 'DRAFT'" :sms-campaign="smsCampaign" />
    </div>
    <div class="w-full max-w-7xl mx-auto my-10">
      <RouterView :sms-campaign="smsCampaign" />
    </div>
  </div>
</template>

<script>
import { smsCampaignsClient } from '@/api/clients';
import NavigationTabs from './components/NavigationTabs.vue';

export default {
  components: {
    NavigationTabs,
  },
  props: {
    smsCampaignId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      smsCampaign: null,
    };
  },
  computed: {
    tabs() {
      if (this.smsCampaign === null) {
        return [];
      }

      const vm = this;

      return [
        {
          label: 'Overview',
          route: {
            name: 'accounts.smsCampaigns.smsCampaignId',
            params: {
              accountId: this.smsCampaign.account_id,
              smsCampaignId: this.smsCampaignId,
            },
          },
          meta: {},
          isActive() {
            return vm.$route.name === this.route.name;
          },
        },
      ];
    },
  },
  watch: {
    '$route.query': {
      handler(query) {
        if ('updated' in query) {
          this.fetchData();
        }
      },
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const response = await smsCampaignsClient.read(this.smsCampaignId, {
          include: [
            'account',
            'model',
            'smsMessage',
            'thirdPartyService',
            'recipientsCount',
            'phoneNumbersCount',
            'phoneNumbersPendingCount',
            'phoneNumbersSentCount',
            'phoneNumbersFailedCount',
          ],
        });

        this.smsCampaign = response.data;

        if (this.$route.name !== 'accounts.smsCampaigns.smsCampaignId') {
          return;
        }

        if (response.data.status === 'DRAFT') {
          this.$router.replace({
            name: 'accounts.smsCampaigns.smsCampaignId.setup',
            params: {
              accountId: this.smsCampaign.account_id,
              smsCampaignId: this.smsCampaign.id,
            },
          });
          return;
        }

        this.$router.replace({
          name: 'accounts.smsCampaigns.smsCampaignId.overview',
          params: {
            accountId: this.smsCampaign.account_id,
            smsCampaignId: this.smsCampaign.id,
          },
        });
      } catch (error) {
        //
      }
    },
  },
};
</script>
